module.exports = __webpack_public_path__ + "static/media/active-row.f049e27a.svg";